import styles from "./styles.module.css";

const Temas = (props) => {
    const { tags } = props;
    return (
        <>
            <div className={`${styles['container-temas']}` }>
                {tags && tags.map( ({name, slug, _id}) => (
                    <div  className={`${styles['tema']}`} key={_id}>
                        <h2>{name}</h2>
                        <a title={`Ver más notas de ${name}`} href={`/tag/${slug}`} >
                            Ver notas
                        </a>
                    </div>
                ))}        
            </div>
        </>
    );
};

export default Temas;
